import { Reveal } from "./Reveal";
import { INDUSTRIES } from "../../data";

export const Industries = () => {
  return (
    <section id="industries" data-testid="industries" className="relative py-28 lg:py-40 border-t border-hairline">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Reveal className="mb-16 max-w-3xl">
          <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Industries We Serve</span>
          <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-parchment mt-6 text-balance">
            Expertise across the <span className="italic text-gold">new economy.</span>
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-hairline">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.group} delay={i * 0.06}>
              <div className="group border-r border-b border-hairline p-8 lg:p-10 h-full hover:bg-surface/40 transition-colors duration-500">
                <h3 className="font-serif text-3xl font-light text-parchment tracking-tight group-hover:text-gold transition-colors duration-300">{ind.group}</h3>
                <ul className="mt-6 space-y-2.5">
                  {ind.items.map((it) => (
                    <li key={it} className="flex items-center gap-3 text-sm text-stone">
                      <span className="h-px w-4 bg-gold/60" />
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
